<template>
  <Stack class="stk-p-8">
    <!-- Hero-style header -->
    <Title>
      Manage Integrations
    </Title>

    <Title class="tw-text-xl tw-mt-10">
      Connect Directly
    </Title>

    <!-- Tile-based layout -->
    <div class="rows">
      <OAuthIntegrationCard
        v-for="app in integrations"
        :key="app.name"
        :app="app"
        :code="code"
        :authorized-app="authorizedApp"
      />
    </div>

    <Title class="tw-text-xl tw-mt-10">
      Set Up Guides for Custodian/Aggregator Integrations
    </Title>
    <IntegrationsLinks />
  </Stack>
</template>

<script>
import OAuthIntegrationCard from '../components/OAuthIntegrationCard.vue';

// Help Center links for custodian integrations
// TODO: Migrate to the new OAuth system for these
import IntegrationsLinks from '@frontend/dash3/js/components/integrations/generic/IntegrationsLinks.vue';

import {
  Stack,
  Title,
} from '@stakeui';

export default {
  name: 'OAuthIntegrationDashboard',
  components: {
    OAuthIntegrationCard,
    IntegrationsLinks,
    Title,
    Stack,
  },
  data() {
    return {
      integrations: [],
      code: null,
      authState: null,
    };
  },
  computed: {
    headers() {
      return {
        'X-CSRFToken': this.$root.$data.csrfToken,
        'Content-Type': 'application/json',
      };
    },
    authorizedApp() {
      if (!this.authState) return null;
      const state = JSON.parse(atob(this.authState));
      return state.app;
    },
    // Group integrations into rows of 3
    groupedIntegrations() {
      const result = [];
      for (let i = 0; i < this.integrations.length; i += 3) {
        result.push(this.integrations.slice(i, i + 3));
      }
      return result;
    },
  },
  created() {
    this.getIntegrations();
    this.getParams();
  },
  methods: {
    async getIntegrations() {
      const res = await fetch('/api/v1/oauth/integrations/', {
        method: 'GET',
        headers: this.headers,
      });
      const data = await res.json();
      this.integrations = data;
    },
    getParams() {
      this.code = this.$route.query.code;
      this.authState = this.$route.query.state;

      if (this.code && this.authState) {
        this.$router.replace({ query: {} });
      }
    },
  },
};
</script>

<style scoped>
.rows {
  display: grid;
  gap: 1.5rem;
  grid-template-columns: repeat(auto-fill, minmax(24rem ,1fr));
}
</style>
